import React, { useState } from 'react';

const CareersNewsletter: React.FC = () => {
  const [email, setEmail] = useState('');
  const [isSubscribed, setIsSubscribed] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (email) {
      console.log('Subscribing email:', email);
      setIsSubscribed(true);
      setEmail('');
      
      setTimeout(() => {
        setIsSubscribed(false);
      }, 3000);
    }
  };

  return (
    <section className="careers-section careers-newsletter">
      <div className="container">
        <h2 className="section-title">Stay in the loop</h2>
        <p className="section-subtitle">
          Subscribe for insights on cloud computing, AI innovations, and the future of technology education.
        </p>
        
        <form className="newsletter-form" onSubmit={handleSubmit}>
          <input
            type="email"
            className="newsletter-input"
            placeholder="Enter your email address"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <button type="submit" className="newsletter-btn">Subscribe</button>
        </form>
        
        {isSubscribed && (
          <p className="success-message">Thank you for subscribing!</p>
        )}
      </div>
    </section>
  );
};

export default CareersNewsletter;